import {useMemo} from 'react';
import {matchPath, useLocation} from 'react-router-dom';

const defaultOptions = {
    placeOrderPrefix: '/place-order',
    hideRightSideBarRoutes: ['/dashboard'],
    hideBottomRoutes: [],
};

const normalizeToArray = (value) => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
};

const isRouteMatched = (pathname, routePatterns) => {
    return routePatterns.some((pattern) => {
        if (!pattern) return false;
        if (pattern === pathname) return true;

        return Boolean(
            matchPath(pathname, {
                path: pattern,
                exact: true,
            })
        );
    });
};

const useDashboardLayoutVisibility = (options = {}) => {
    const location = useLocation();

    return useMemo(() => {
        const merged = {...defaultOptions, ...options};
        const pathname = location?.pathname || '';

        const isPlaceOrderFlow = Boolean(merged.placeOrderPrefix) && pathname.startsWith(merged.placeOrderPrefix);

        const hideRightSideBarRoutes = normalizeToArray(merged.hideRightSideBarRoutes);
        const hideBottomRoutes = normalizeToArray(merged.hideBottomRoutes);

        const isRightSideBarHiddenByRoute = isRouteMatched(pathname, hideRightSideBarRoutes);
        const isBottomHiddenByRoute = isRouteMatched(pathname, hideBottomRoutes);

        const showRightSideBar = !isPlaceOrderFlow && !isRightSideBarHiddenByRoute;
        const showBottom = !isPlaceOrderFlow && !isBottomHiddenByRoute;

        return {
            pathname,
            isPlaceOrderFlow,
            showRightSideBar,
            showBottom,
        };
        // eslint-disable-next-line
    }, [
        location?.pathname,
        options?.placeOrderPrefix,
        options?.hideRightSideBarRoutes,
        options?.hideBottomRoutes,
    ]);
};

export default useDashboardLayoutVisibility;
